import { apiGet } from './index'

export type PricingPrice = {
  id: string
  currency: string
  unit_amount: number | null
  interval: string | null
  interval_count: number | null
  trial_days: number | null
}

export type PricingProduct = {
  key: string
  group: 'individual' | 'station' | 'credits' | 'seat_addon'
  label: string
  description: string
  bullets: string[]
  active: boolean
  available: boolean
  seat_addon_key?: string
  credit_amount?: number
  price?: PricingPrice | null
}

export type PricingResponse = {
  currency: string
  supported_currencies: string[]
  products: PricingProduct[]
  prices_by_currency?: Record<string, Record<string, PricingPrice | null>>
  last_updated?: string | null
}

export type PricingType = 'plans' | 'credits'

export type PricingRequestOptions = {
  force?: boolean
  debug?: boolean
  allCurrencies?: boolean
}

export function getPricing(
  type: PricingType,
  currency?: string,
  options?: PricingRequestOptions,
): Promise<PricingResponse> {
  const search = new URLSearchParams()

  if (type) {
    search.set('type', type)
  }

  if (currency) {
    search.set('currency', currency)
  }

  if (options?.force) {
    search.set('force', '1')
  }

  if (options?.debug) {
    search.set('debug', '1')
  }

  if (options?.allCurrencies) {
    search.set('all_currencies', '1')
  }

  const path = `billing/pricing?${search.toString()}`
  return apiGet<PricingResponse>(path)
}
